import { mapActions, mapGetters } from 'vuex';

import { REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';

export default {
  REQUEST_LIFECYCLE,
  computed: {
    ...mapGetters('dashboard/workOrderMatches', [
      'workOrdersMatchesKey',
      'getJobsMetaByStatusAlias',
      'getRawJobsByStatusAlias',
    ]),
    meta () {
      return this.getJobsMetaByStatusAlias(this.jobsStatusAlias, this.workOrdersMatchesKey);
    },
    rawJobs () {
      return this.getRawJobsByStatusAlias(this.jobsStatusAlias, this.workOrdersMatchesKey);
    },
  },
  methods: {
    ...mapActions('dashboard/workOrderMatches', [
      'fetchWorkOrderMatches',
      'resetWorkOrderMatches',
    ]),

  },
};
